module.exports = __webpack_public_path__ + "h5/img/logo-tfo.bdcb163d.png";